<template>
    <div class="foot_outbox">
        <div class="foot_content">
            <!-- <a href="">
                <img src="../../assets/logo.png" alt="">
            </a> -->
            <div class="href_box">
                <div class="href_one">
                    <div class="logo_box">
                        <img src="../../assets/feiwulogo.png" alt="">
                    </div>
                    <ul class="duijiebox">
                        <li><a href="#" @click="toTesturl">平台对接</a></li>
                        <li>|</li>
                        <li><a :href="baseUrl + '/profile/upload/2024/02/20/%E9%A3%9E%E5%B1%8B%E6%99%BA%E6%85%A7%E6%95%99%E5%AD%A6%E7%AE%A1%E7%90%86%E5%B9%B3%E5%8F%B0%E6%8E%A5%E5%8F%A3%E5%AF%B9%E6%8E%A5_v1.0_20240220103211A003.pdf'">平台协议</a>
                        </li>
                    </ul>

                    <ul>
                        <!-- <li><a href="#">联系我们</a></li> -->
                        <li><a href="#"><img src="../../assets/3.1电话.png" alt=""> 电话:15000236983</a></li>
                        <li><a href="#"><img src="../../assets/邮箱.png" alt=""> 邮箱:402854416@qq.com</a></li>
                        <li><a href="#"><img src="../../assets/地址.png" alt=""> 地址:南京市建邺区白龙江东街9号新城科技园科技创新综合体B5栋三层315室</a>
                        <!-- <li><a href="#"><img src="../../assets/地址.png" alt=""> 地址:南京市雨花台区铁心桥街道中国（南京）软件谷芯创产业园-B栋二层203室</a> -->
                        </li>
                    </ul>
                </div>
                <div class="erweima">
                    <canvas ref="canvas"></canvas>
                </div>
            </div>
        </div>
        <div class="beian">
            <img src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" alt=""> <a href="https://beian.miit.gov.cn/"
                target="_blank" style="color: #fff;">苏ICP备2021050757号-2</a>
        </div>
    </div>
</template>
<script>
import QRCode from 'qrcode';
import { BASE_URL } from "@/utils/request.js";
export default {
    name: 'foot-foot',
    data() {
        return {
            baseUrl: BASE_URL,
        }
    },
    mounted() {
        this.generateQRCode('http://www.feiwuxr.com/');
    },
    methods: {
        generateQRCode(link) {
            QRCode.toCanvas(this.$refs.canvas, link, function (error) {
                if (error) console.error(error);
            });
        },
        toTesturl() {
            this.$router.push({
                path: '/testexp'
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.logo_box {
    margin-right: 10%;
}

.erweima {

    width: 110px;
    height: 110px;
    display: flex;
    align-items: center;
    color: #fff;
    margin-top: -30px;
    flex-direction: column;

    canvas {
        width: 100% !important;
        height: 100% !important;
        margin-bottom: 10px;
    }
}

.foot_outbox {
    width: 100%;
    height: 260px;
    background-color: #191919;
    padding: 10px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    >.foot_content {
        // max-width: 1400px;
        width: 100%;
        margin: auto;
        height: 100%;
        box-sizing: border-box;
        padding: 10px 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        padding-top: 20px;
        padding-right: 120px;
        border-bottom: 1px solid #f3f3f3;

        >a {
            width: 15%;
            height: 100%;
            font-size: 18px;

            >img {
                width: 100%;
                height: 100%;
            }
        }
    }
}

.href_box {
    width: 100%;
    max-width: 1600px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    display: flex;

    >.href_one {
        width: 1200px;
        padding-left: 150px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        width: 100%;

        >ul:nth-child(1) {
            width: 567px;
            font-size: 14px;
            margin-right: 120px;

            >p {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 300;
                color: #FFFFFF;
                line-height: 40px
            }
        }

        >ul:nth-child(2) {
            margin-right: 180px;

            >li {
                margin-bottom: 22PX;
            }
        }

        >ul:last-child {
            >li {
                padding: 1px 0;
                margin-bottom: 23px;

                >a {
                    display: flex;
                    align-items: center;

                    >img {
                        margin-right: 10px;
                    }
                }
            }
        }

        li {
            margin: 5px 0;
        }
    }

    a {
        color: #f8f8f8;
        font-size: 14px;
    }
}

.beian {
    height: 60px;
    display: flex;
    align-items: center;
    color: #fff;
    justify-content: center;
    font-size: 14px;

    >img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
    }

    // >span {}
}

.duijiebox {
    display: flex;
    box-sizing: border-box;
    padding-top: 5px;

    li {
        margin: 0 20px !important;
    }
}

</style>
<style lang="scss" scoped>
  @media (max-width:550px){
    .foot_outbox > .foot_content{
        padding: 0;
    }
    .href_box{
        display: flex;
        padding: 10px;
        box-sizing: border-box;
        position: relative;
    }
    .href_one{
        display: flex;
        padding-left: 0px!important;
        // background-color: red;
        margin-left: 0!important;
        height: 100%;
        flex-direction: column;
        width: 100%;
        >.duijiebox{
            display: flex;
            // background-color: orange;
            width: 100%;
        }
        >ul:nth-child(3){
            >li{
                margin-bottom: 0!important;
                >a{
                    display: flex;
                    align-items: flex-start!important;
                }
            }
        }

        // background-color: orange;
    }
    .href_box > .href_one > ul:nth-child(2){
        box-sizing: border-box;
        padding-left: 23px;
        >li{
            margin: 0 5px!important;
        }
    }
    .erweima{
        position: absolute;
        right: 8%;
        top: 25%;
        canvas{
            height: 100%;
            margin-bottom: 0;
        }
    }
  }
</style>